import { useNavigate } from "react-router-dom";
import { FiHeart } from "react-icons/fi";
import { useWishlist } from "../context/WishlistContext";

const ProductCard = ({ product }) => {
  const navigate = useNavigate();
  const { wishlist, toggleWishlist } = useWishlist();

  const isInWishlist = wishlist.some(item => item._id === product._id);

  const handleWishlistClick = (e) => {
    e.stopPropagation(); // Prevent navigating to product page
    toggleWishlist(product);
  };

  const savings = product.originalPrice > product.price ? product.originalPrice - product.price : 0;
  const discountPercent = product.originalPrice > product.price
    ? Math.round(((product.originalPrice - product.price) / product.originalPrice) * 100)
    : 0;

  return (
    <div
      onClick={() => navigate(`/product/${product._id}`)}
      className="group relative cursor-pointer bg-white overflow-hidden shadow-sm hover:shadow-xl transition-shadow duration-300"
    >
      {/* Discount Badge */}
      {discountPercent > 0 && (
         <div className="absolute top-2 left-2 bg-gray-800 text-white text-xs font-bold px-2 py-1 rounded shadow-sm z-10">
    {discountPercent}% OFF
  </div>
      )}

      {/* Wishlist Heart Icon */}
      <div
        onClick={handleWishlistClick}
        className={`absolute top-2 right-2 z-10 p-1 rounded-full cursor-pointer transition-colors duration-300 
          ${isInWishlist ? 'bg-red-100 text-red-600' : 'bg-white text-gray-400 hover:bg-red-50 hover:text-red-600'}`}
        title={isInWishlist ? "Remove from wishlist" : "Add to wishlist"}
      >
        <FiHeart size={18} />
      </div>

      {/* Product Image */}
      <div className="aspect-[2/3] overflow-hidden bg-gray-100">
        <img
          // src={product.image}
           src={product.mainImage}
          alt={product.name}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
        />

       

   
      </div>

      {/* Product Info */}
      <div className="p-4 text-center">
        <h3 className="text-sm font-medium text-gray-800 mb-1 truncate">
          {product.name}
        </h3>

        {/* Price Section */}
       
<div className="flex items-center justify-center gap-2 flex-wrap">
  
 <span className="text-xs md:text-sm font-medium  text-gray-600 tracking-wide">
  ₹{product.price.toLocaleString()}
</span>

  {product.originalPrice > product.price && (
    <span className="line-through text-gray-400 text-xs md:text-sm">
      ₹{product.originalPrice.toLocaleString()}
    </span>
  )}

  {savings > 0 && (
    <span className="ml-auto text-[10px] md:text-xs font-medium text-green-700 bg-green-50 border border-green-200 px-2 py-[2px] rounded-full">
      Save ₹{savings.toLocaleString()}
    </span>
  )}

</div>
      </div>
    </div>
  );
};

export default ProductCard;